module.exports = __webpack_public_path__ + "static/media/Arosa_klein.eb628f7b.mp3";